/*
 *  Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
 *  is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
 *  and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
 *
 *  You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
 *  in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
 *  forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
 *  explicitly covering such access.
 *
 *  The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
 *  which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
 *
 *  ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
 *  CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
 *  INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
 *  OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
 *  THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.
 *
 */

import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment'
import './device-card.less'
import cameraImage from 'assets/images/camera.svg'
import {
  CameraOutlined,
  ClockCircleOutlined,
  DownCircleOutlined, DownOutlined,
  HeartFilled,
  PictureOutlined,
  UploadOutlined
} from '@ant-design/icons'
import { List } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { DeviceStatus, DeviceType } from 'constants/device'
import classnames from 'classnames'
import VList from 'react-list'
import MaskLoading from '../MaskLoading'

const {scrollTo} = VList

interface IDevice {
  deviceID: number
  imgCount: number
  time: string
  deviceType: string
  status: number
  onlineStatus: number
}
const DeviceTypeDictionary = {
  [DeviceType.TwoW]: '2w',
  [DeviceType.FourW]: '4w',
  [DeviceType.Lite360Master]: '360',
  [DeviceType.Lite360Slave]: '360'
}
const DeviceCard = (props) => {
  const { device, onChange} = props

  const onCardClick = () => {
    const action ={ type: 'showDetail', payload: device.deviceID}
    onChange(action)
  }
  const handleUpload = (event)=>{
    event.stopPropagation()
    const action = {type: 'upload',payload: {...device}}
    onChange(action)
  }
  const cardBackStyle = classnames('card-back', { selected: device.selected })
  const uploadStyle = classnames('icon-outline',{hide: device.deviceType === DeviceType.Lite360Slave})
  return (
    <div className={cardBackStyle} onClick={onCardClick}>
      <div className={'card'}>
        <div className={'card-left' + ' ' + (device.onlineStatus === 1 ? 'online' : 'offline')}>
          <img src={cameraImage} />
        </div>
        <div className={'card-right'}>
          <div className={'card-right-up'}>
            <span>
              {device.deviceID}
            </span>
            <span className={'icon-outline'} style={{opacity:0}} >
              <DownOutlined className={'icon'}/>
            </span>
            <span className={uploadStyle} onClick={handleUpload} >
              <UploadOutlined className='icon'/>
            </span>
          </div>
          <div className={'card-right-down'}>
            <span>
              <PictureOutlined className={'indicator'} />
              {device.totalImageCount}
            </span>
            <span>
              <ClockCircleOutlined className={'indicator'} />
              {device.onlineTime ? moment(device.onlineTime * 1000).format('DD/MM/YYYY'): '--/--/--'}
          </span>
            <span>
              <CameraOutlined className={'indicator'} />
              {DeviceTypeDictionary[device.deviceType]}
            </span>
            <HeartFilled style={{color: device.status === DeviceStatus.Healthy ? '#00B14F' : '#F09800'}} />
          </div>
        </div>
      </div>
    </div>
  )
}


const DeviceCardList = props => {
  const { cameraList, loading, selectedCamera } = useSelector(({ cameras, loading }) => ({
    cameraList: cameras.cameraList,
    loading: loading.effects.cameras.fetchCameras,
    selectedCamera : cameras.selectedCamera
  }))
  const { cameras: { updateSelectedCamera,updateUploadingCamera } } = useDispatch()
  const vlistRef = useRef(null)
  const onChange = (action) => {
    const { type, payload } = action
    switch (type) {
      case 'showDetail':
        updateSelectedCamera(payload)
        break
      case 'upload':
        updateUploadingCamera(payload)
        break
      default: break
    }
  }
  useEffect(() =>{
    const selectedIndex = cameraList.findIndex(item => item.deviceID === selectedCamera)
    if(selectedIndex > -1 && vlistRef.current){
      vlistRef.current.scrollTo(selectedIndex)
    }
  },[selectedCamera,vlistRef.current])
  const listItemRender = (index,key) =>{
    const item = cameraList[index]
    return (
       <DeviceCard  key = {key} device={{...item, selected: item.deviceID === selectedCamera}} onChange={onChange} />
    )
  }
  return (
    <div className={'card-list'}>
      {
        loading
          ? <MaskLoading/>
          : <VList ref={vlistRef} itemRenderer={listItemRender} length={cameraList.length} type={'uniform'} useStaticSize={true} />
      }
    </div>
  )
}
export {
  DeviceCard as default,
  DeviceCardList
}
